export default __webpack_public_path__ + "static/media/cloud--2.74b69fa4.svg";